<div class="form" [formGroup]="form">
  <crm-wfm-file-upload-input
    [validationParseData]="dayWeightsValid"
    (uploadedData)="uploadDayWeights($event)"
  ></crm-wfm-file-upload-input>
  <table
    mat-table
    multiTemplateDataRows
    [dataSource]="dayWeightsDataSource"
    [formArrayName]="forecastWeights.dayWeightsGroup"
  >
    <ng-container matColumnDef="{{ column }}" *ngFor="let column of dayWeightsColumnsToDisplay; let d = index">
      <th mat-header-cell *matHeaderCellDef>{{ column | date : 'EEE' | titlecase }}</th>
      <td mat-cell *matCellDef="let element; let w = dataIndex" #cells>
        <ng-container *ngFor="let dayIndex of [d + w * 7]">
          <ng-container *ngIf="dayIndex >= weekStartOffset && dayIndex < weekEndOffset">
            <div class="weight-block-controls-container">
              <span class="weight-block-day-number">{{ days[dayIndex] }}</span>
              <mat-checkbox
                class="weight-block-custom-checkbox"
                matTooltip="{{ 'wfmModule.tooltips.forecastAddCustomSet' | transloco }}"
                [checked]="isCustomEnabled(days[dayIndex])"
                (change)="changeCustomInterval(days[dayIndex], $event.checked)"
              ></mat-checkbox>
            </div>
            <div class="weight-block">
              <input
                class="weight-block-weight-number"
                type="number"
                matInput
                [formControlName]="dayIndex - weekStartOffset"
              />
            </div>
            <mat-error *ngIf="isInvalid(dayIndex - weekStartOffset)">
              {{ 'wfmModule.errors.incorrectValue' | transloco }}
            </mat-error>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="dayWeightsColumnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: dayWeightsColumnsToDisplay"></tr>
  </table>
</div>
